import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { getParameterByName } from '../../utils/utils';
import ag101CertImage from '../../images/SHA/RegenAg101CertificateOfCompletion.png'


const styles = (theme) => ({
    root: {
        marginLeft: 64,
        paddingTop: 160,
        fontFamily: 'Helvetica',
        '@media (max-width: 400)': {
            marginLeft: 0,
        },
    },
    buttonBar: {
        textAlign: 'right',
        margin: 24,
    },
    certArea: {
        width: '800px',
        textAlign: 'center',
        margin: '24px auto'
    },
    userName: {
        // position: 'absolute',
        fontSize: 22,
        marginTop: -309,
        marginLeft: 254,
        fontFamily: 'inherit',
        textTransform: 'uppercase',
        fontStyle: 'italic',
        color: '#333',
    },
    date: {
      fontSize: 22,
      marginTop: 78,
      marginLeft: 103,
      fontFamily: 'inherit',
      textTransform: 'uppercase',
      fontStyle: 'italic',
      color: '#333',      
    }
});

 

export class CertOfCompletion extends React.PureComponent {
    constructor(...args) {
        super(...args);
        const certImage = getParameterByName('im');
        const completionDate = getParameterByName('date');

        debugger;

        const userRecord = JSON.parse(localStorage.getItem('user'));
        this.state = {
            certImage,
            userName: `${userRecord['custom:firstName']} ${userRecord['custom:lastName']}`, // TODO: Not set yet. Need to adjust udpateUser to used Cognito info to pull in info from DB.
            completionDate,
            isPrinting: false,
        };
    }

    componentDidMount = async () => {
     
    };

    handlePrint = (event) => {
        event.persist();
        const printDiv = document.getElementById('printArea').innerHTML;

        // window.frames["print_frame"].document.body.innerHTML=printDiv;
        // window.frames["print_frame"].window.focus();
        // window.frames["print_frame"].window.print();

// var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
// WinPrint.document.write(printDiv);
// WinPrint.document.close();
// WinPrint.focus();
// WinPrint.print();
// WinPrint.close();
        this.setState({isPrinting: true}, () => {
            var printContents = document.getElementById('printArea').innerHTML;
            var originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();

            this.setState({isPrinting: false}, () => {
              //  document.body.innerHTML = originalContents;
                window.history.back();
            })
        })

    };

    cancel = () => {
        window.history.back();
    }

    render() {
       const { classes } = this.props;

        return (
            <div className={classes.root}>

                {!this.state.isPrinting && (
                    <div className={classes.buttonBar}>
                        <Button onClick={this.cancel}>Cancel</Button>
                        <Button onClick={this.handlePrint} variant="contained" color="primary">PRINT</Button>
                    </div>
                )}
                <div style={{height: 700, margin: 24}}>
                <div id='printArea' >
                <div 
                    style={{
                        width: '900px',
                        textAlign: 'center',
                        margin: '0px auto'
                    }}
                >
                    <img src={this.state.certImage} alt="Regen Ag Online Certificate" width="860px" align="middle"/>
                            {this.state.isPrinting
                            ?
                            <>
                                <div
                                    style={{

                                        fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                        fontSize: 22,
                                        marginTop: -300,
                                        marginLeft: 250,
                                        textTransform: 'uppercase',
                                        fontStyle: 'italic',
                                        color: '#333',
                                        // border: '1px solid gray'
                                    }}
                                >
                                    {this.state.userName}
                                </div>
                                <div
                                    style={{

                                        fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                        fontSize: 22,
                                        marginTop: 78,
                                        marginLeft: 103,
                                        textTransform: 'uppercase',
                                        fontStyle: 'italic',
                                        color: '#333',
                                        // border: '1px solid gray'
                                    }}
                                >
                                    {this.state.completionDate}
                                </div>
                              </>
                            :
                    <>
                      <div className={classes.userName} >
                        {this.state.userName}
                      </div>
                      <div className={classes.date} >
                        {this.state.completionDate}
                      </div>
                    </>
                  }
                  
                 
                </div>
                </div>
                </div>
            </div>
        );
    }
}

CertOfCompletion.propTypes = {
    courseName: PropTypes.string,
    completionDate: PropTypes.string,
    user: PropTypes.object,
};

export default withStyles(styles)(CertOfCompletion);
